import axios from "axios";
import {authHeader} from "@/helpers/authservice/auth-header";
import {requiredHeaders} from "../../helpers/authservice/requiredHeaders";
import {apiRequestsHelper} from "@/state/pinia/apiRequestHelper";
import {log} from "./log";
import {defineStore} from "pinia";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";

export const usePaymentsManagerModule = defineStore("paymentsManagerModule", {
    state: () => ({
        lazyLoaderModule: useLazyLoaderModule(),
        paymentsEndpoint: "/api/payments-manager/payments",
        settingsEndpoint: "/api/settings",

        //Common
        backendModuleName: "PAYMENTS",


        //User data
        user: {},

        //Settings
        settings: [],

        //Payments
        payments: [],
        paymentsPagesCount: 0,
        paymentsTotal: 0,
        paymentsHeaders: [],
        paymentsSearchKeys: [],
        paymentsFilterKeys: [],
        paymentDocuments: [],
        paymentDocumentsPagesCount: 0,
        paymentDocumentsTotal: 0,
        paymentDocumentsHeaders: [],
        paymentDocumentsSearchKeys: [],
        availableBanks: [],

        //Row - payments documents map
        paymentDocumentsMapForCurrentRows: {}, //key - rowId (documentId#drugstoreId), value - paymentDocument object

        paymentsVisibleHeaders: ["id_dokumentu", "id_apteki", "nazwa_dostawcy", "numer_dokumentu", "data_utworzenia", "termin_platnosci", "wartosc_brutto", "suma_platnosci","typ_platnosci_dok"],
        paymentsVisibleHeadersTitlesMap: {
            "status": "Status",
            "id_dokumentu": "IdDokf",
            "id_apteki": "Apteka",
            "nazwa_dostawcy": "Nazwa dostawcy",
            "numer_dokumentu": "Numer dokumentu",
            "data_utworzenia": "Data utworzenia",
            "dg_utw_platnosci_centralnej": "Data płatności centralnej",
            "wartosc_brutto": "Wartość",
            "suma_platnosci": "Zapłacono",
            "numer_dok_plat": "Numer dokumentu płatności",
            "uwagi": "Uwagi",
            "nip": "NIP",
            "termin_platnosci": "Termin",
            "typ_platnosci_dok":"Kredytowany"

        }
    }),
    getters: {
        //Common
        getBackendModuleName: (state) => state.backendModuleName,
        getPaymentsManagerSettings: (state) => state.settings,

        //Payments
        getPayments: (state) => state.payments,
        getPaymentsPagesCount: (state) => state.paymentsPagesCount,
        getPaymentsTotal: (state) => state.paymentsTotal,
        getPaymentsHeaders: (state) => state.paymentsHeaders,
        getPaymentsSearchKeys: (state) => state.paymentsSearchKeys,
        getPaymentsFilterKeys: (state) => state.paymentsFilterKeys,
        getPaymentDocuments: (state) => state.paymentDocuments,
        getPaymentDocumentsPagesCount: (state) => state.paymentDocumentsPagesCount,
        getPaymentDocumentsTotal: (state) => state.paymentDocumentsTotal,
        getPaymentDocumentsHeaders: (state) => state.paymentDocumentsHeaders,
        getPaymentDocumentsSearchKeys: (state) => state.paymentDocumentsSearchKeys,
        getPaymentDocumentsMapForCurrentRows: (state) => state.paymentDocumentsMapForCurrentRows,
        getPaymentsVisibleHeaders: (state) => state.paymentsVisibleHeaders,
        getPaymentsVisibleHeadersTitlesMap: (state) => state.paymentsVisibleHeadersTitlesMap,
        getAvailableBanks: (state) => state.availableBanks
    },
    actions: {
        // mutations
        setPaymentsManagerSettings(settings) {
            this.settings = settings;
        },

        //Payments
        setPayments(payments) {
            this.payments = payments;
        },
        setPaymentsHeaders(paymentsHeaders) {
            this.paymentsHeaders = paymentsHeaders
        },
        setPaymentsSearchKeys(paymentsSearchKeys) {
            this.paymentsSearchKeys = paymentsSearchKeys
        },
        setPaymentsFilterKeys(paymentsFilterKeys) {
            this.paymentsFilterKeys = paymentsFilterKeys
        },
        setPaymentsPagesCount(pagesCount) {
            this.paymentsPagesCount = pagesCount;
        },
        setPaymentsTotal(total) {
            this.paymentsTotal = total;
        },
        setPaymentDocuments(paymentDocuments) {
            this.paymentDocuments = paymentDocuments;
        },
        setPaymentDocumentsPagesCount(pagesCount) {
            this.paymentDocumentsPagesCount = pagesCount;
        },
        setPaymentDocumentsTotal(total) {
            this.paymentDocumentsTotal = total;
        },

        setPaymentDocumentsHeaders(paymentDocumentsHeaders) {
            this.paymentDocumentsHeaders = paymentDocumentsHeaders;
        },
        setPaymentDocumentsSearchKeys(paymentDocumentsSearchKeys) {
            this.paymentDocumentsSearchKeys = paymentDocumentsSearchKeys;
        },
        setPaymentDocumentsMapForCurrentRows(paymentDocumentsMap) {
            this.paymentDocumentsMapForCurrentRows = paymentDocumentsMap;
        },
        setAvailableBanks(availableBanks) {
            this.availableBanks = availableBanks;
        },

        // actions
        // =================================================== new api for payments ================================================

        //Settings
        httpGetPaymentsManagerSettings() {
            const endpoint = this.settingsEndpoint + "/module/" + this.backendModuleName;
            return axios({
                method: "get",
                url: endpoint,
                headers: authHeader(),
                data: {},
            })
                .then((response) => {
                    if (response.status === 200) {
                        log.log("Displaying settings payload:");
                        log.log(response.data.payload);
                        this.setPaymentsManagerSettings(response.data.payload);
                    } else if (response.status === 203) {
                        log.log(response);
                    } else {
                        var errorMessage = "";
                        if (response.data.message) {
                            errorMessage = response.data.message;
                        }
                        log.log("Wystąpił błąd!: " + errorMessage);
                    }
                })
                .catch((error) => {
                    log.log("Wystąpił błąd!: " + error);
                });
        },
        httpGetPaymentsDataPaging(payload) {
            var pageNumber = payload.currentPage;
            var filterRequestObject = payload.searchAndFilterRequest;
            var paidStatus = payload.paidStatus;

            var endpoint_last_part = "/all?page=";
            var endpoint = this.paymentsEndpoint + endpoint_last_part + pageNumber;
            if (paidStatus !== null && paidStatus !== undefined) {
                endpoint = endpoint + "&paidStatus=" + paidStatus;
            }
            if (payload.sortingKey) {
                endpoint = endpoint + "&sortingKey=" + payload.sortingKey;
            }
            if (payload.sortingDirection) {
                endpoint = endpoint + "&sortingDirection=" + payload.sortingDirection;
            }

            return axios({
                method: "post",
                url: endpoint,
                headers: requiredHeaders(),
                data: filterRequestObject,
            })
                .then((response) => {
                    log.log("Response from httpGetPaymentsDataPaging:");
                    log.log(response);
                    if (response.status === 200) {
                        this.setPaymentsPagesCount(response.data.payload.totalPages
                        );
                        this.setPaymentsTotal(response.data.payload.totalElements
                        );
                        this.setPayments(response.data.payload.content);
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, false);
                })
                .catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpGetPaymentsDataPaging");
                });

        },

        httpPayForDocuments(payload) {
            var documentsToPay = payload.documentsToPay;
            var ignoreNotValidPayments = payload.ignoreNotValidPayments;

            var endpoint = this.paymentsEndpoint + "/pay";
            if (ignoreNotValidPayments) {
                endpoint = endpoint + "?ignoreNotValidPayments=" + ignoreNotValidPayments;
            }

            return axios({
                method: "post",
                url: endpoint,
                headers: requiredHeaders(),
                data: documentsToPay,
                timeout: 60000, // 60 seconds
            });

        },

        httpGetPaymentHeaders() {
            var endpoint = this.paymentsEndpoint + "/headers";
            return axios({
                method: "get",
                url: endpoint,
                headers: {
                    Authorization: authHeader(),
                    'authMethod': 'CUSTOM_JWT'
                },
                data: {},
            }).then((response) => {
                if (response.status === 200) {
                    log.log("HEADERS::")
                    log.log(response.data.payload);
                    this.setPaymentsHeaders(response.data.payload);
                }
                return apiRequestsHelper.handleResponseWithDialogs(response, false);
            })
                .catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpGetPaymentHeaders");
                });
        },

        httpGetPaymentSearchKeys() {
            var endpoint = this.paymentsEndpoint + "/search-keys";
            return axios({
                method: "get",
                url: endpoint,
                headers: {
                    Authorization: authHeader(),
                    'authMethod': 'CUSTOM_JWT'
                },
                data: {},
            }).then((response) => {
                if (response.status === 200) {

                    log.log(response.data.payload);
                    this.setPaymentsSearchKeys(response.data.payload);
                }
                return apiRequestsHelper.handleResponseWithDialogs(response, false);
            })
                .catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpGetPaymentSearchKeys");
                });
        },

        httpGetPaymentsAvailableFilters(params) {
            var endpoint = this.paymentsEndpoint + "/available-filters";
            if (params && Object.keys(params).length > 0) {
                const query = new URLSearchParams(params).toString();
                endpoint = endpoint + "?" + query;
            }
            return axios({
                method: "get",
                url: endpoint,
                headers: {
                    Authorization: authHeader(),
                    'authMethod': 'CUSTOM_JWT'
                },
                data: {},
            })
        },

        httpGetLocalAndCentralPaymentsForDocument(payload) {
            var endpoint = this.paymentsEndpoint + "/created/drugstoreId/" + payload.drugstoreId + "/documentId/" + payload.documentId;
            return axios({
                method: "get",
                url: endpoint,
                headers: {
                    Authorization: authHeader(),
                    'authMethod': 'CUSTOM_JWT'
                },
                data: {},
            })
        },


        httpSynchronisePayments() {
            var endpoint = this.paymentsEndpoint + "/synchronise";
            return axios({
                method: "get",
                url: endpoint,
                headers: {
                    Authorization: authHeader(),
                    'authMethod': 'CUSTOM_JWT'
                },
                data: {},
            }).then((response) => {
                return apiRequestsHelper.handleResponseWithDialogs(response, true);
            })
                .catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpSynchronisePayments");
                });
        },

        httpGetPaymentDocumentsHeaders() {
            var endpoint = this.paymentsEndpoint + "/documents/headers";
            return axios({
                method: "get",
                url: endpoint,
                headers: {
                    Authorization: authHeader(),
                    'authMethod': 'CUSTOM_JWT'
                },
                data: {},
            }).then((response) => {
                if (response.status === 200) {

                    log.log(response.data.payload);
                    this.setPaymentDocumentsHeaders(response.data.payload);
                }
                return apiRequestsHelper.handleResponseWithDialogs(response, false);
            })
                .catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpGetPaymentDocumentsHeaders");
                });
        },

        httpGetPaymentDocumentsSearchKeys() {
            var endpoint = this.paymentsEndpoint + "/documents/search-keys";
            return axios({
                method: "get",
                url: endpoint,
                headers: {
                    Authorization: authHeader(),
                    'authMethod': 'CUSTOM_JWT'
                },
                data: {},
            }).then((response) => {
                if (response.status === 200) {

                    log.log(response.data.payload);
                    this.setPaymentDocumentsSearchKeys(response.data.payload);
                }
                return apiRequestsHelper.handleResponseWithDialogs(response, false);
            })
                .catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpGetPaymentDocumentsSearchKeys");
                });
        },

        httpGetPaymentDocumentsDataPaging(payload) {
            var pageNumber = payload.currentPage;
            var filterRequestObject = payload.searchAndFilterRequest;


            var endpoint_last_part = "/documents/all?page=";
            var endpoint = this.paymentsEndpoint + endpoint_last_part + pageNumber;

            if (payload.sortingKey) {
                endpoint = endpoint + "&sortingKey=" + payload.sortingKey;
            }
            if (payload.sortingDirection) {
                endpoint = endpoint + "&sortingDirection=" + payload.sortingDirection;
            }

            return axios({
                method: "post",
                url: endpoint,
                headers: requiredHeaders(),
                data: filterRequestObject,
            })
                .then((response) => {
                    if (response.status === 200) {
                        this.setPaymentDocumentsPagesCount(response.data.payload.totalPages
                        );
                        this.setPaymentDocumentsTotal(response.data.payload.totalElements
                        );
                        this.setPaymentDocuments(response.data.payload.content);
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, false);
                })
                .catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpGetPaymentDocumentsDataPaging");
                });

        },

        httpGetPaymentDocumentByGuid(payload) {
            var documentGuid = payload.documentGuid;
            var endpoint = this.paymentsEndpoint + "/documents/guid/" + documentGuid;
            return axios({
                method: "get",
                url: endpoint,
                headers: requiredHeaders(),
                data: {},
            })

        },
        httpGetSupplierAndDrugstoreForPaymentDocumentByGuid(payload) {
            var documentGuid = payload.documentGuid;
            var endpoint = this.paymentsEndpoint + "/documents/guid/" + documentGuid + "/supplier-drugstore";
            return axios({
                method: "get",
                url: endpoint,
                headers: requiredHeaders(),
                data: {},
            })

        },

        httpGetPaymentDocumentsMap(payload) {

            var rowsUniqueIds = payload.rowsIds;

            var endpoint_last_part = "/created-payments-documents-map";
            var endpoint = this.paymentsEndpoint + endpoint_last_part;

            return axios({
                method: "post",
                url: endpoint,
                headers: requiredHeaders(),
                data: rowsUniqueIds,
            })
                .then((response) => {
                    if (response.status === 200) {
                        this.setPaymentDocumentsMapForCurrentRows(response.data.payload
                        );
                    }
                    return apiRequestsHelper.handleResponseWithDialogs(response, false);
                })
                .catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpGetPaymentDocumentsMap");
                });

        },

        httpCreateDocuments(payload) {
            var createDocumentRequests = payload.createDocumentRequests;
            var ignoreNotValidPayments = payload.ignoreNotValidPayments;

            var endpoint = this.paymentsEndpoint + "/documents/create";
            if (ignoreNotValidPayments) {
                endpoint = endpoint + "?ignoreNotValidPayments=" + ignoreNotValidPayments;
            }

            return axios({
                method: "post",
                url: endpoint,
                headers: requiredHeaders(),
                data: createDocumentRequests,
            });

        },

        httpUpdateDocuments(payload) {
            var documentDto = payload.paymentDocument;
            log.log("Updating document:");
            log.log(documentDto);
            var documentGuid = payload.documentGuid;

            var endpoint = this.paymentsEndpoint + "/documents/update/" + documentGuid;


            return axios({
                method: "put",
                url: endpoint,
                headers: requiredHeaders(),
                data: documentDto,
            }).then((response) => {
                return apiRequestsHelper.handleResponseWithDialogs(response, true);
            })
                .catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpUpdateDocuments");
                });

        },

        httpRemovePaymentDocumentByGuid(payload) {
            var documentGuid = payload.documentGuid;
            var endpoint = this.paymentsEndpoint + "/documents/remove/" + documentGuid;

            return axios({
                method: "delete",
                url: endpoint,
                headers: requiredHeaders(),
                data: {},
            }).then((response) => {
                return apiRequestsHelper.handleResponseWithDialogs(response, true);
            })
                .catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpRemovePaymentDocumentByGuid");
                });
        },

        httpRemoveAllPaymentDocumentsByGuid(payload) {
            var endpoint = this.paymentsEndpoint + "/remove/all/guid";

            return axios({
                method: "delete",
                url: endpoint,
                headers: requiredHeaders(),
                data: payload.documentGuids,
            }).then((response) => {
                return apiRequestsHelper.handleResponseWithDialogs(response, true);
            })
                .catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpRemoveAllPaymentDocumentsByGuid");
                });
        },


        httpBindRawDocumentWithExtData() {

            var endpoint = this.paymentsEndpoint + "/fulfill-extended-payments-data";
            return axios({
                method: "get",
                url: endpoint,
                headers: requiredHeaders(),
                data: {},
            }).then((response) => {
                return apiRequestsHelper.handleResponseWithDialogs(response, true);
            })
                .catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpBindRawDocumentWithExtData");
                });

        },

        httpIgnorePayments(payload) {
            log.log("Ignoring payments:");
            log.log(payload);
            var rowsUniqueIds = payload.rowsIds;
            var reportGuid = payload.reportGuid;

            var endpoint = this.paymentsEndpoint + "/ignore/" + reportGuid;
            return axios({
                method: "post",
                url: endpoint,
                headers: requiredHeaders(),
                data: rowsUniqueIds,
            });
        },

        httpUnIgnorePayments(payload) {
            var rowsUniqueIds = payload.rowsIds;
            var reportGuid = payload.reportGuid;

            var endpoint = this.paymentsEndpoint + "/unignore/" + reportGuid;
            return axios({
                method: "post",
                url: endpoint,
                headers: requiredHeaders(),
                data: rowsUniqueIds,
            });
        },

        httpExportPaymentsDataToFile(payload) {
            var outputFileFormat = payload.outputFileFormat;
            var pageNumber = payload.currentPage;
            var filterRequestObject = payload.searchAndFilterRequest;
            var paidStatus = payload.paidStatus;

            var endpoint_last_part = "/export/all?page=";
            var endpoint = this.paymentsEndpoint + endpoint_last_part + pageNumber;
            if (paidStatus !== null && paidStatus !== undefined) {
                endpoint = endpoint + "&paidStatus=" + paidStatus;
            }
            if (payload.sortingKey) {
                endpoint = endpoint + "&sortingKey=" + payload.sortingKey;
            }
            if (payload.sortingDirection) {
                endpoint = endpoint + "&sortingDirection=" + payload.sortingDirection;
            }

            if (outputFileFormat) {
                endpoint = endpoint + "&outputFileFormat=" + outputFileFormat;
            }

            return axios({
                method: "post",
                url: endpoint,
                headers: requiredHeaders(),
                data: filterRequestObject,
            });

        },


        httpExportPaymentDocumentItemsToFile(payload) {
            var outputFileFormat = payload.outputFileFormat;
            var paymentDocumentGuid = payload.paymentDocumentGuid;

            var endpoint = this.paymentsEndpoint + "/documents/export/items/" + paymentDocumentGuid;

            if (outputFileFormat) {
                endpoint = endpoint + "?outputFileFormat=" + outputFileFormat;
            }

            if (outputFileFormat === "XLSX" || outputFileFormat === "XLS") {
                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: {},
                    responseType: 'blob' // required for binary data and files types
                });
            } else {
                return axios({
                    method: "post",
                    url: endpoint,
                    headers: requiredHeaders(),
                    data: {},

                });
            }

        },

        httpSendEmailWithPaymentDocumentData(payload) {
            var mailMessage = payload.mailMessage;
            var paymentDocumentGuid = payload.paymentDocumentGuid;
            var endpoint = this.paymentsEndpoint + "/documents/" + paymentDocumentGuid + "/send/email";
            log.log("mailMessage", mailMessage)
            return axios({
                method: "post",
                url: endpoint,
                headers: requiredHeaders(),
                data: mailMessage,
            });

        },

        httpGetAvailableBanks() {


            const endpoint = `${this.paymentsEndpoint}/available-banks`;
            return axios({
                method: "get",
                url: endpoint,
                headers: requiredHeaders(),
                data: {},
                timeout: 60000, // 60 seconds for larger files
            })
                .then((response) => {

                    if (response.status === 200) {
                        this.setAvailableBanks(response.data.payload)
                        new Promise((resolve) => {
                            resolve(response)
                        });
                    } else {
                        return apiRequestsHelper.handleResponseWithDialogs(response, false);
                    }
                })
                .catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpGetAvailableBanks");
                });
        },


        httpGenerateBankWireFile(payload) {
            const bankKey = payload.bankKey;
            const paymentDocumentGuid = payload.paymentDocumentGuid;

            const endpoint = `${this.paymentsEndpoint}/documents/${paymentDocumentGuid}/bank-wire/${bankKey}`;
            return axios({
                method: "post",
                url: endpoint,
                headers: requiredHeaders(),
                data: {},
                timeout: 60000, // 60 seconds for larger files
            })
                .then((response) => {

                    if (response.status === 200) {
                        return new Promise((resolve) => {
                            resolve(response)
                        });
                    } else {
                        return apiRequestsHelper.handleResponseWithDialogs(response, false);
                    }
                })
                .catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpGenerateBankWireFile");
                });
        },


    }


});
